import { useRouter } from 'vue-router';
import { useMatrixPageOrigin } from './useMatrixPageOrigin';

export function useEditUploadRecord() {
  const router = useRouter();
  const { prefix, returnQuery } = useMatrixPageOrigin();

  // No open and no lock: the sheet edit of an Upload record is guarded by the response number.
  async function editUploadRecord(recordId: number): Promise<void> {
    await router.push({
      name: 'EditarRegistro',
      params: { prefix: prefix(), recordId: String(recordId) },
      ...returnQuery(),
    });
  }

  return { editUploadRecord };
}
